import PayrollReportOptions from './PayrollReportOptions'
import SubMenu from './SubMenu'

const PayrollReports = () => (
    <SubMenu componentOptions={PayrollReportOptions} />
)

export default PayrollReports